import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  createCompanyProduct,
  getDefaultProducts,
  getProductByCompanyId,
} from "../../../services/product-service";
import { modalStyle } from "../../../utils/modal-style";

export default function CreateProductModal({ open, setOpen, id }) {
  const accessToken = localStorage.getItem("token");
  const [selectList, setSelectList] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(undefined);
  const [price, setPrice] = useState("");
  const handleClose = () => setOpen(false);

  async function handleSubmit(e) {
    e.preventDefault();
    const data = {
      name: selectedProductId,
      price,
      company_id: id,
    };

    try {
      const result = await createCompanyProduct(accessToken, data);
      console.log(result);
      alert("Produto cadastrado com sucesso.");
      setOpen(false);
    } catch (error) {
      alert("Ops, algo deu errado. Tente novamente mais tarde.");
    }
  }

  useEffect(() => {
    async function getProducts() {
      const defaultProd = await getDefaultProducts(accessToken);
      const companyProducts = await getProductByCompanyId(accessToken, id);

      const filteredProducts = defaultProd.filter(
        (d) =>
          !companyProducts.some((c) => {
            return d.name === c.name;
          })
      );

      if (companyProducts.length === 0) setSelectList(defaultProd);
      setSelectList(filteredProducts);
    }
    getProducts();
  }, [accessToken, id]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className="box-container"
        sx={{ ...modalStyle, width: "400px", height: "250px" }}
      >
        <form onSubmit={handleSubmit} className="form-container">
          <h1>Novo produto</h1>

          <FormControl>
            <InputLabel id="demo-simple-select-autowidth-label">
              Produtos
            </InputLabel>
            <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              value={selectedProductId}
              onChange={(e) => {
                setSelectedProductId(e.target.value);
              }}
              autoWidth
              label="Produtos"
            >
              {selectList?.map((item) => (
                <MenuItem key={`${item.id}-${item.name}`} value={item.name}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {selectedProductId ? (
            <>
              <TextField
                label="Preço"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                type="number"
                inputProps={{
                  autoComplete: "off",
                  step: "0.0001",
                }}
              />

              <Button size="medium" type="submit" variant="contained">
                Cadastrar
              </Button>
            </>
          ) : (
            ""
          )}
        </form>
      </Box>
    </Modal>
  );
}
